import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React, { useContext, useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { theme } from '@spa/offer/theme';
import { useScrollToSection } from '@spa/offer/hooks/scrollToSection';
import PhotosCarousel from './PhotosCarousel';
import GallerySection from './GallerySection';
import Modal from '@spa/shared/components/Modal';
import { CloseIcon } from '@spa/shared/svg/close';
import FloorPlanSection from './FloorPlanSection';
import ShareAndWishlist from './ShareAndWishlist';
import ArrowBack from '@spa/shared/svg/arrow-back';
import { MediaContext } from '@spa/shared/contexts/media';
import Button from '@spa/shared/components/Unisystem/Button';
import { getPropertyRentBy } from '@spa/shared/utils/property';
import { PHOTOS_MODAL_SECTIONS } from '@spa/offer/constants/modals';
import { translateFromLanguage } from '@spa/shared/utils/transformers';
import { RENT_BY_TRANSLATIONS, UNIT_TYPE_TRANSLATIONS } from '@spa/shared/constants/translations';
import TitleModal from '@spa/offer/components/Modals/PhotosModal/TitleModal';
import VideoSection from '@spa/offer/components/Modals/PhotosModal/VideoSection';
import { ModalGlobalStyle, Wrapper, HeaderModal, Content, Heading, ChipsWrapper, Chips, ChipsCarousel, ChipsFloorPlan, ChipsVideo, TitleWrapper } from './styles';
import Chip from '@spa/shared/components/Unisystem/Chip';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { trackQuickGalleryNavigation } from '@spa/offer/store/actions/tracking';
import { modalIds } from '../modal-displayer';
var PhotosModal = function PhotosModal(_ref) {
  var _SECTION_CONFIGS;
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    rentBy = _ref.rentBy,
    offerId = _ref.offerId,
    _ref$neighborhoodTran = _ref.neighborhoodTranslations,
    neighborhoodTranslations = _ref$neighborhoodTran === void 0 ? [] : _ref$neighborhoodTran,
    _ref$cityTranslations = _ref.cityTranslations,
    cityTranslations = _ref$cityTranslations === void 0 ? [] : _ref$cityTranslations,
    floorPlanName = _ref.floorPlanName,
    hasVideo = _ref.hasVideo,
    activeSection = _ref.activeSection,
    unitName = _ref.unitName,
    setActiveSection = _ref.setActiveSection,
    photosGrid = _ref.photosGrid,
    isActive = _ref.isActive,
    trackQuickGalleryNavigationAction = _ref.trackQuickGalleryNavigationAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  var scrollToSection = useScrollToSection();
  var wrapperRef = useRef(null);
  var _useState = useState(true),
    showTitle = _useState[0],
    setShowTitle = _useState[1];
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (wrapperRef.current) {
        setShowTitle(wrapperRef.current.scrollTop === 0);
      }
    };
    var wrapper = wrapperRef.current;
    wrapper === null || wrapper === void 0 ? void 0 : wrapper.addEventListener('scroll', handleScroll);
    return function () {
      return wrapper === null || wrapper === void 0 ? void 0 : wrapper.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(function () {
    if (!unitName) {
      return;
    }
    setShowTitle(false);
    var timeout = setTimeout(function () {
      return scrollToSection(unitName);
    }, 500);
    return function () {
      return clearTimeout(timeout);
    };
  }, []);
  var renderChips = function renderChips(className) {
    var _sectionConfig, _sectionConfig$active;
    var sectionConfig = (_sectionConfig = {}, _defineProperty(_sectionConfig, PHOTOS_MODAL_SECTIONS.floor_plan.label, [].concat(_toConsumableArray(hasVideo ? ['video'] : []), ['photos'])), _defineProperty(_sectionConfig, PHOTOS_MODAL_SECTIONS.video.label, [].concat(_toConsumableArray(floorPlanName ? ['floor_plan'] : []), ['photos'])), _defineProperty(_sectionConfig, PHOTOS_MODAL_SECTIONS.photos.label, [].concat(_toConsumableArray(floorPlanName ? ['floor_plan'] : []), _toConsumableArray(hasVideo ? ['video'] : []))), _defineProperty(_sectionConfig, PHOTOS_MODAL_SECTIONS.carousel.label, [].concat(_toConsumableArray(floorPlanName ? ['floor_plan'] : []), _toConsumableArray(hasVideo ? ['video'] : []))), _sectionConfig);
    var sections = (_sectionConfig$active = sectionConfig[activeSection]) !== null && _sectionConfig$active !== void 0 ? _sectionConfig$active : [];
    return sections.map(function (section) {
      return __jsx(Chip, {
        key: section,
        isPrimary: true,
        isSmall: true,
        label: t(PHOTOS_MODAL_SECTIONS[section].label),
        icon: PHOTOS_MODAL_SECTIONS[section].icon,
        onClick: function onClick() {
          return handleChipClick(PHOTOS_MODAL_SECTIONS[section].label);
        },
        className: className
      });
    });
  };
  var handleButtonCloseClick = function handleButtonCloseClick() {
    isActive && isCarousel ? setActiveSection(PHOTOS_MODAL_SECTIONS.photos.label) : onClose();
  };
  var location = translateFromLanguage(neighborhoodTranslations, language) || translateFromLanguage(cityTranslations, language) || '';
  var handleChipClick = function handleChipClick(label, shouldScroll) {
    trackQuickGalleryNavigationAction(label);
    if (shouldScroll) {
      setShowTitle(false);
      var moveToSection = function moveToSection() {
        return scrollToSection(label);
      };
      setTimeout(moveToSection, 300);
      clearTimeout(moveToSection);
      return;
    }
    setActiveSection(label);
  };
  var SECTION_CONFIGS = (_SECTION_CONFIGS = {}, _defineProperty(_SECTION_CONFIGS, PHOTOS_MODAL_SECTIONS.carousel.label, {
    desktopChips: !is.mobile && __jsx(ChipsCarousel, null, renderChips()),
    mobileContent: is.mobile && __jsx(ChipsCarousel, null, renderChips()),
    content: __jsx(PhotosCarousel, null)
  }), _defineProperty(_SECTION_CONFIGS, PHOTOS_MODAL_SECTIONS.photos.label, {
    desktopChips: !is.mobile && __jsx(ShareAndWishlist, null),
    additionalContent: __jsx(ChipsWrapper, null, __jsx(Chips, null, Object.keys(photosGrid || {}).map(function (unitTypeKey) {
      var _unitTypeKey$split = unitTypeKey.split(':'),
        _unitTypeKey$split2 = _slicedToArray(_unitTypeKey$split, 2),
        unitType = _unitTypeKey$split2[0],
        unitIndex = _unitTypeKey$split2[1];
      var translatedType = t(UNIT_TYPE_TRANSLATIONS[unitType]);
      var label = "".concat(translatedType, " ").concat(unitIndex !== null && unitIndex !== void 0 ? unitIndex : '').trim();
      return __jsx(Chip, {
        isSmall: true,
        minWidth: 'auto',
        label: label,
        key: unitTypeKey,
        onClick: function onClick() {
          return handleChipClick(label, true);
        }
      });
    }), renderChips('extra-chips'))),
    content: __jsx(GallerySection, null)
  }), _defineProperty(_SECTION_CONFIGS, PHOTOS_MODAL_SECTIONS.floor_plan.label, {
    desktopChips: !is.mobile && __jsx(ChipsFloorPlan, null, renderChips()),
    mobileChips: is.mobile && __jsx(ChipsFloorPlan, null, renderChips()),
    content: floorPlanName && __jsx(FloorPlanSection, {
      floorPlanName: floorPlanName
    })
  }), _defineProperty(_SECTION_CONFIGS, PHOTOS_MODAL_SECTIONS.video.label, {
    desktopChips: !is.mobile && __jsx(ChipsVideo, null, renderChips()),
    mobileChips: is.mobile && __jsx(ChipsVideo, null, renderChips()),
    content: hasVideo && __jsx(VideoSection, null)
  }), _SECTION_CONFIGS);
  var currentConfig = SECTION_CONFIGS[activeSection] || {};
  var isGallery = PHOTOS_MODAL_SECTIONS.photos.label == activeSection;
  var isCarousel = PHOTOS_MODAL_SECTIONS.carousel.label == activeSection;
  return __jsx(Modal, {
    width: '100%',
    height: '100%',
    className: "photos-modal ".concat(isCarousel ? 'photos-carousel' : ''),
    withHeader: false,
    onClose: onClose,
    onOutsideClickOrPressEsc: handleButtonCloseClick
  }, __jsx(ModalGlobalStyle, {
    isGallery: isGallery
  }), __jsx(HeaderModal, {
    isGallery: isGallery
  }, __jsx(Button, {
    onClick: handleButtonCloseClick,
    isGhost: true
  }, isCarousel ? __jsx(React.Fragment, null, __jsx(CloseIcon, {
    color: theme.photosModal.carouselSection.closeIconColor
  }), t('Close')) : __jsx(React.Fragment, null, __jsx(ArrowBack, {
    color: theme.colors.cornFlowerBlue
  }), t('Back to listing'))), currentConfig.desktopChips, currentConfig.mobileContent, !(is.mobile && isCarousel) && __jsx(Heading, null, __jsx(TitleWrapper, {
    show: showTitle
  }, __jsx(TitleModal, {
    title: {
      __html: "".concat(t(rentBy), " \u2022 <span>").concat(location, "</span>")
    },
    reference: offerId
  })), isCarousel && !is.mobile && __jsx(ShareAndWishlist, null)), currentConfig.mobileChips, currentConfig.additionalContent), __jsx(Wrapper, {
    ref: wrapperRef,
    id: "photos-modal-wrapper"
  }, __jsx(Content, null, currentConfig.content)));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _neighborhood$metadat, _modals;
  var _ref2$offer = _ref2.offer,
    offerAggregate = _ref2$offer.offerAggregate,
    photosGrid = _ref2$offer.photosModal.photosGrid,
    modals = _ref2.modal.modals;
  var _offerAggregate$accom = offerAggregate.accommodation_offer;
  _offerAggregate$accom = _offerAggregate$accom === void 0 ? {} : _offerAggregate$accom;
  var offerId = _offerAggregate$accom.id,
    unitType = _offerAggregate$accom.property.unit_type,
    _offerAggregate$accom2 = _offerAggregate$accom.floor_plan;
  _offerAggregate$accom2 = _offerAggregate$accom2 === void 0 ? {} : _offerAggregate$accom2;
  var floorPlanName = _offerAggregate$accom2.name,
    _offerAggregate$prope = offerAggregate.property_aggregate;
  _offerAggregate$prope = _offerAggregate$prope === void 0 ? {} : _offerAggregate$prope;
  var _offerAggregate$prope2 = _offerAggregate$prope.property;
  _offerAggregate$prope2 = _offerAggregate$prope2 === void 0 ? {} : _offerAggregate$prope2;
  var lifecycle = _offerAggregate$prope2.lifecycle,
    typology = _offerAggregate$prope2.typology,
    video = _offerAggregate$prope2.video,
    _offerAggregate$prope3 = _offerAggregate$prope.neighborhood,
    neighborhood = _offerAggregate$prope3 === void 0 ? {} : _offerAggregate$prope3,
    _offerAggregate$globa = offerAggregate.globalization_aggregate;
  _offerAggregate$globa = _offerAggregate$globa === void 0 ? {} : _offerAggregate$globa;
  var _offerAggregate$globa2 = _offerAggregate$globa.city;
  _offerAggregate$globa2 = _offerAggregate$globa2 === void 0 ? {} : _offerAggregate$globa2;
  var _offerAggregate$globa3 = _offerAggregate$globa2.metadata;
  _offerAggregate$globa3 = _offerAggregate$globa3 === void 0 ? {} : _offerAggregate$globa3;
  var cityNameTranslations = _offerAggregate$globa3.name_translations;
  var modal = modals.find(function (_ref3) {
    var modalId = _ref3.modalId;
    return modalId === modalIds.PHOTOS_MODAL;
  });
  return {
    offerId: offerId,
    floorPlanName: floorPlanName,
    photosGrid: photosGrid,
    rentBy: RENT_BY_TRANSLATIONS[getPropertyRentBy({
      unitType: unitType,
      lifecycle: lifecycle,
      typology: typology
    })],
    neighborhoodTranslations: neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$metadat = neighborhood.metadata) === null || _neighborhood$metadat === void 0 ? void 0 : _neighborhood$metadat.name_translations,
    cityTranslations: cityNameTranslations,
    hasVideo: !!(video !== null && video !== void 0 && video.url),
    activeSection: modal === null || modal === void 0 ? void 0 : modal.section,
    unitName: modal === null || modal === void 0 ? void 0 : modal.unitName,
    isActive: ((_modals = modals[modals.length - 1]) === null || _modals === void 0 ? void 0 : _modals.modalId) === modalIds.PHOTOS_MODAL
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setActiveSection: function setActiveSection(section) {
      return dispatch(showModalAction({
        modalId: modalIds.PHOTOS_MODAL,
        section: section
      }));
    },
    trackQuickGalleryNavigationAction: function trackQuickGalleryNavigationAction(label) {
      return dispatch(trackQuickGalleryNavigation({
        label: label
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PhotosModal);